import React from 'react';
import VSymbolRender from './VSymbolRender';

export const VSymbol = ({...props}:React.ParamHTMLAttributes<SVGSVGElement>):JSX.Element=>{
	return <VSymbolRender {...props}/>;
};